import gql from 'graphql-tag'
import { V2_PERFORMANCE_COMMENT } from '../fragments/performance'

export const V2_PERFORMANCE_REFLECTIONS = gql`
  query v2PerformanceGetChecklistEvaluations(
    $limit: Int
    $mode: ListChecklistEvaluationMode!
    $page: Int
    $schoolIds: [Int]
    $statuses: [String]
    $evaluationType: V2EvaluationType
    $years: [Int]
    $months: [Int]
    $terms: [Int]
    $weeks: [Int]
    $sortField: V2PerformanceGetChecklistEvaluationsAllowedSortField
    $sortDirection: SortDirection
    $checklistRoles: [String]
    $designations: [String]
    $organisationTitleIds: [String]
    $search: String
  ) {
    v2PerformanceGetChecklistEvaluations(
      limit: $limit
      mode: $mode
      page: $page
      schoolIds: $schoolIds
      statuses: $statuses
      evaluationType: $evaluationType
      years: $years
      months: $months
      weeks: $weeks
      terms: $terms
      sortField: $sortField
      sortDirection: $sortDirection
      checklistRoles: $checklistRoles
      designations: $designations
      organisationTitleIds: $organisationTitleIds
      search: $search
    ) {
      checklistEvaluationStatuses
      checklistRoles
      data {
        id
        status
        role
        year
        term
        week
        updatedAt
        type
        dueDate
        overdue
        checklist {
          id
        }
        period {
          name
          startDate
          endDate
        }
        appraisee {
          name
          designation
          id
          school {
            name
          }
          media {
            url
          }
        }
        participants {
          roleId
          name
          type
          userId
          roleName
        }
        checklistRecords {
          id
          roleId
          value
          checklistId
          normalizedValue
        }
        buttons {
          buttonText
          buttonType
          actionType
          actionParams
        }
        updatedAt
      }
      meta {
        limit
        page
        total
      }
    }
  }
`

export const V2_PERFORMANCE_REFLECTION_DETAIL = gql`
  query v2PerformanceGetChecklistEvaluationDetail($id: Int!, $evaluationType: V2EvaluationType) {
    v2PerformanceGetChecklistEvaluationDetail(id: $id, evaluationType: $evaluationType) {
      ...V2PerformanceChecklistEvaluationDetail
    }
  }

  fragment V2PerformanceChecklistEvaluationDetail on V2PerformanceChecklistEvaluationDetail {
    id
    status
    updatedAt
    roleGroup
    notes {
      title
      description
    }
    appraisee {
      name
      dateJoin
      designation
      organisationTitleId
      school {
        name
      }
    }
    normalizedValue
    generalSettings
    value
    signOffComments: performanceChecklistEvaluationComments(types: [SIGN_OFF_COMMENT]) {
      ...PerformanceComment
    }
    moderationComments: performanceChecklistEvaluationComments(types: [MODERATION_COMMENT]) {
      ...PerformanceComment
    }
    checklistRecords {
      id
      roleId
      checklistId
      value
      normalizedValue
      personalProfileId
    }
    role
    type
    term
    week
    month
    year
    dueDate
    overdue
    participants {
      roleId
      name
      type
      designation
      organisationTitleId
    }
    period {
      name
      startDate
      endDate
    }
    buttons {
      actionParams
      actionType
      buttonText
      buttonType
    }
    performanceChecklistExpectations {
      id
      isFailedExpectation
      performanceChecklistItemId
    }
    permissionSettings
    checklistItems {
      id
      parentId
      name
      order
      hint
      description
      calculationSettings
      generalSettings
      itemContent
      inputSettings
      checklistItemRecords {
        performanceChecklistItemId
        id
        value
        jsonValue
        normalizedValue
        roleId
      }
    }
  }

  ${V2_PERFORMANCE_COMMENT}
`

export const V2_PERFORMANCE_REFLECTION_PROFILES = gql`
  query V2PerformanceGetEvaluationProfiles(
    $mode: ListChecklistEvaluationMode!
    $page: Int!
    $limit: Int
    $evaluationType: V2EvaluationType!
  ) {
    v2PerformanceGetEvaluationProfiles(mode: $mode, page: $page, limit: $limit, evaluationType: $evaluationType) {
      checklistRoles
      designations
      checklistEvaluationStatuses
      data {
        dueDate
        id
        month
        normalizedValue
        role
        roleGroup
        status
        term
        type
        updatedAt
        value
        week
        year
        overdue
        dueDate
        appraisee {
          id
          name
          designation
          school {
            name
          }
          media {
            url
          }
        }
      }
      meta {
        limit
        page
        total
      }
    }
  }
`

export const V2_PERFORMANCE_REFLECTION_PROFILE = gql`
  query V2PerformanceGetEvaluationProfile($evaluationType: V2EvaluationType!, $profileId: Int!, $termId: Int) {
    v2PerformanceGetEvaluationProfile(evaluationType: $evaluationType, profileId: $profileId, termId: $termId) {
      data {
        evaluations {
          dueDate
          id
          month
          normalizedValue
          role
          roleGroup
          status
          term
          type
          updatedAt
          value
          week
          year
          dueDate
          overdue
        }
        profile {
          name
          designation
          media {
            url
          }
        }
      }
    }
  }
`

export const V2_PERFORMANCE_REFLECTION_TERMS = gql`
  query V2PerformanceGetTerms($countryCode: String, $schoolId: Int) {
    v2PerformanceGetTerms(countryCode: $countryCode, schoolId: $schoolId) {
      endDate
      id
      name
      startDate
      termNo
      year
    }
  }
`
